var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoArrowBlueRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.837,
    height: 23.895
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.665.485a1.638 1.638 0 000 2.326l7.535 7.535H1.64a1.638 1.638 0 000 3.276h38.527l-7.5 7.486a1.633 1.633 0 002.31 2.31l10.416-10.422a1.442 1.442 0 000-2.08L34.991.485a1.638 1.638 0 00-2.326 0z",
    fill: "#005fe2"
  })));
}

export default SvgCoArrowBlueRightinline;